var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill Icons / Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3269 11.576L20.3908 10.3273L20.9647 9.4375L23.5811 11.1249C23.7312 11.2218 23.8224 11.3878 23.8235 11.5665C23.8247 11.7451 23.7356 11.9123 23.5867 12.0111L12.2926 19.5001C12.1153 19.6177 11.8848 19.6177 11.7074 19.5001L0.413323 12.0111C0.265633 11.9131 0.176735 11.7478 0.176484 11.5706C0.176232 11.3934 0.26466 11.2278 0.412071 11.1295L2.94126 9.44201L3.5289 10.3228L1.66182 11.5685L12 18.4237L22.3269 11.576Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3269 15.1053L20.3908 13.8566L20.9647 12.9668L23.5811 14.6542C23.7312 14.7511 23.8224 14.9171 23.8235 15.0958C23.8247 15.2744 23.7356 15.4416 23.5867 15.5404L12.2926 23.0294C12.1153 23.147 11.8848 23.147 11.7074 23.0294L0.413323 15.5404C0.265633 15.4424 0.176735 15.2771 0.176484 15.0999C0.176232 14.9227 0.26466 14.7571 0.412071 14.6588L2.94126 12.9713L3.5289 13.8521L1.66182 15.0978L12 21.9529L22.3269 15.1053Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7093 0.263455C11.8858 0.147533 12.1142 0.147533 12.2907 0.263455L23.5848 7.68316C23.7339 7.7811 23.8236 7.94752 23.8235 8.12589C23.8235 8.30427 23.7336 8.4706 23.5844 8.56839L12.2903 15.9722C12.114 16.0878 11.886 16.0878 11.7098 15.9722L0.415647 8.56839C0.266473 8.4706 0.176571 8.30426 0.176483 8.12589C0.176395 7.94752 0.266134 7.7811 0.415212 7.68316L11.7093 0.263455ZM1.67082 8.12516L12 14.8964L22.3292 8.12516L12 1.33936L1.67082 8.12516Z",
    fill: "inherit"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/Floor.e71e47a71abe2e4379279d237c2fd317.svg";
export { ForwardRef as ReactComponent };